import { BaseURLs } from '@/types/Enums/BaseURLs'
import { GetToken } from '@/utils-ts'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

const token = GetToken()
const isLocal = window.location.hostname === 'localhost'
const apiHub = isLocal ? BaseURLs.API_HUB : `${window.location.origin}/apiHub/`
export const Hub = new HubConnectionBuilder()
  .withUrl(apiHub, {
    accessTokenFactory: () => {
      return token ?? ''
    },
  })
  .configureLogging(LogLevel.None)
  .build()

if (import.meta.env.PROD) void Hub.start()

async function start() {
  try {
    await Hub.start()
  } catch (_err) {
    setTimeout(() => start(), 5000)
  }
}

Hub.onclose(() => {
  setTimeout(async () => {
    await start()
  }, 15000)
})
